import { Component, OnDestroy, OnInit } from '@angular/core';
import { ChangelogService } from '../../../app/core/services/changelog/changelog-service';
import { AuthService } from '../../../app/core/services/auth/auth';
import { Subscription } from 'rxjs/internal/Subscription';

@Component({
  selector: 'app-footer',
  imports: [],
  templateUrl: './footer.html',
  styleUrl: './footer.css',
})
export class Footer implements OnInit, OnDestroy {
  private subscriptions = new Subscription();
  currentYear: number = new Date().getFullYear();
  version = '';

  constructor(
    private authService: AuthService,
    private changelogService: ChangelogService
  ) {}

ngOnInit(): void {
    this.subscriptions.add(
      this.changelogService.version$.subscribe((ver) => {
        this.version = ver;
      })
    );

    this.subscriptions.add(
      this.authService.token$.subscribe((token) => {
        if (!token) {
          this.version = '';
          return;
        }
        this.changelogService.getLatestVersion().subscribe();
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}

